import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import * as Yup from "yup";
import useImageUploader from "../hooks/UploadImage";
import { useFormik } from "formik";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";
import ConfirmModal from "../Modal/ConfirmModal";
import { isPdfExtensions } from "../utils/commFunction";
import toast from "react-hot-toast";

const validationSchema = Yup.object({
  award: Yup.string().required("Award is required"),
  // level: Yup.string().required("Level is required"),
  // education: Yup.string().required("Educational or Union Body is required"),
  cretificate: Yup.mixed().required("Certificate is required"),
});

export default function Accreditations() {
  const location = useLocation();
  const queryClient = useQueryClient();
  const Navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const { uploadImage, loading, error, uploadedUrl, errorMessage } = useImageUploader();  // Call the hook here
  const { data: accredtationIdDetails, error: PaccredtationError, isLoading: accredtationLoading } = useQuery({
    queryKey: ["accredtationIdDetails"],
    queryFn: () => getRequest(`/accreditation/details${location?.search}`),
    enabled: !!location?.search,
  });

  useEffect(() => {
    if (!location?.search) {
      queryClient.setQueryData(["accredtationIdDetails"], null);
    }
  }, [location?.search, queryClient]);

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      if (location.search) {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('accredtationId'); // Get the 'id' query param
        const modifyData = {
          id: id,
          award: data?.award || "",
          // level: data?.level || "",
          // education: data?.education || "",
          cretificate: data?.cretificate || "",
        };
        return putRequest(`/accreditation/edit`, modifyData);
      } else {
        const modifyData = {
          award: data?.award || "",
          // level: data?.level || "",
          // education: data?.education || "",
          cretificate: data?.cretificate || "",
        };
        return postRequest(`/accreditation/create`, modifyData);
      }

    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
        },
    })
      Navigate(-1)
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };

  const intial = {
    award: "",
    // level: "",
    // education: "",
    cretificate: "",
  }

  const formik = useFormik({
    initialValues: accredtationIdDetails?.data || intial,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      mutate(values)
    },
  });

  useEffect(() => {
    if (uploadedUrl) {
      formik.setFieldValue("cretificate", uploadedUrl); // Set the uploaded image URL
    }
  }, [uploadedUrl])

  console.log("formik.values.cretificate", formik.values.cretificate)



  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate(-1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Accreditations & Qualifications
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Accreditations & Qualifications</h4>
                  </div>
                  <div className="my-profile-box-contain">
                    <div className="my-profile-box-form">
                      <Form className="cmn-form-set" onSubmit={formik.handleSubmit}>
                        <Form.Group className="mb-3" controlId="award">
                          <Form.Label>Award</Form.Label>
                          <Form.Control
                            type="text"
                            name="award"
                            value={formik.values.award}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Type here"
                          />
                          {formik.errors.award && formik.touched.award && (
                            <div className="text-danger">{formik.errors.award}</div>
                          )}
                        </Form.Group>

                        {/* <Form.Group className="mb-3" controlId="level">
                          <Form.Label>Level</Form.Label>
                          <Form.Select
                            name="level"
                            value={formik.values.level}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            type="select"
                          >
                            <option value="">Select</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </Form.Select>
                          {formik.errors.level && formik.touched.level && (
                            <div className="text-danger">{formik.errors.level}</div>
                          )}
                        </Form.Group> */}

                        {/* <Form.Group className="mb-3" controlId="education">
                          <Form.Label>Educational or Union Body</Form.Label>
                          <Form.Control
                            type="text"
                            name="education"
                            value={formik.values.education}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Type here"
                          />
                          {formik.errors.education && formik.touched.education && (
                            <div className="text-danger">{formik.errors.education}</div>
                          )}
                        </Form.Group> */}

                        <div className="certificate-upld">
                          <Form.Label>Certificate</Form.Label>
                          <div className="certificate-img">
                            {isPdfExtensions(formik.values.cretificate) ?
                              (
                                <img
                                  src={require("../assets/images/pdfIMG.png")}
                                  alt="pdf icon"
                                />
                              ) :
                              (
                                <img
                                  src={formik.values.cretificate || require("../assets/images/dimmy-img.png")}
                                  alt="certificate"
                                />
                              )}

                            <div className="cmpny-logo-upld">
                              <Form.Control
                                type="file"
                                name="cretificate"
                                accept="image/*, .pdf" 
                                onChange={async (event) => {
                                  const file = event.target.files[0];
                                  if (file) {
                                    await uploadImage(file); // Wait for image upload
                                    formik.setFieldValue("cretificate", uploadedUrl); // Set the uploaded image URL
                                  }
                                }}
                              />
                            
                              <button className="white-btn">Upload Certificate</button>
                            </div>
                          
                          </div>
                          {formik.errors.cretificate && formik.touched.cretificate && (
                                <div className="text-danger">{formik.errors.cretificate}</div>
                              )}
                        </div>

                        <div className="d-flex gap-4">
                          <button type="submit" className="theme-comm-btn">
                            Submit
                          </button>
                          {location.search &&
                            <button type="button" className="theme-red-comm-btn" onClick={() => handleDelete("accreditations")}>
                              Delete
                            </button>}
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>

        <ConfirmModal
          data={location.search}
          isModalOpen={isModalOpen}
          selectedType={selectedType}
          handleConfirmClose={handleConfirmClose}
        />
      </Layout>
    </>
  );
}

